import PropTypes from "prop-types";
import React from "react";
import { FetchController } from "ui/fetch/fetch-controller";

class FetchParamMappingController extends React.PureComponent {
  static get propTypes() {
    return {
      children: PropTypes.element.isRequired,
      fetchObject: FetchController.propTypes.fetchObject,
      injectAs: PropTypes.string.isRequired,
    };
  }

  constructor() {
    super();

    this.fetchId = `param-maps-${Date.now()}`;
    this.state = {
      legacyParams: new Set(),
      loaded: false,
    };

    this.fetcher = this.fetcher.bind(this);
  }

  fetcher() {
    return this.props.fetchObject().then((resp) => {
      const legacyParams = this.transform(resp.data.data);

      this.setState({
        legacyParams,
        loaded: true,
      });
    });
  }

  transform(payload) {
    const legacyParams = new Set();

    return Object.values(payload).reduce((acc, v3map) => {
      Object.values(v3map).forEach((v3) => acc.add(v3));

      return acc;
    }, legacyParams);
  }

  render() {
    const { loaded, legacyParams } = this.state;
    const { children, injectAs } = this.props;

    return (
      <FetchController
        fetchObject={this.fetcher}
        injectAs={injectAs}
        object={legacyParams}
        objectId={this.fetchId}
        objectLoaded={loaded}
      >
        {children}
      </FetchController>
    );
  }
}

export { FetchParamMappingController };
